<template>
  <section class="contacts-list">
    <page-header></page-header>
    <div class="list">
      <div class="h-scrollable-content" ref="headertable">
        <div class="excel-header-wrap">
          <div class="excel-header">
            <div class="row">
              <template v-for="(item, index) in header">
                <table-header-cell
                  v-if="item.search"
                  :key="index"
                  :label="item.label"
                  :column="item.column"
                  :cssClass="item.cssClass"
                  hasSearch
                  :filters="filters"
                  @search="activateSearch(item)"
                  @add-row="addRow"
                ></table-header-cell>
                <table-header-cell
                  v-else
                  :key="index"
                  :label="item.label"
                  :column="item.column"
                  :cssClass="item.cssClass"
                  @add-row="addRow"
                ></table-header-cell>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div
        class="v-scrollable-content"
        ref="bodytable"
        @scroll="matchScroll"
        @click="selectRow(null)"
      >
        <div class="freeze" ref="freezedtable">
          <div class="excel-table freezed">
            <div
              v-for="(item, index) in data"
              :key="index"
              class="row"
              @mouseover="item.isHover = true"
              @mouseleave="item.isHover = false"
              :class="{
                'is-new': item.isNew,
                'is-selected': item.isSelected,
                'has-error': item.hasError ? item.hasError : false,
                'edit-mode': item.isEdit,
                'is-hover': item.isHover
              }"
              @click.stop="changeToEditMode(item)"
            >
              <template v-for="(cell, j) in header">
                <table-cell
                  v-if="j <= 1"
                  v-model="data[index]"
                  :key="j"
                  :cssClass="header[j].cssClass"
                  :column="header[j].column"
                  :list="header[j].list"
                  :type="header[j].type"
                  :readonly="header[j].readOnly"
                  :allowCreate="header[j].allowCreate"
                  :remoteMethod="header[j].remoteMethod"
                  :selectedColumn="selectedColumn"
                  @saved="changeToReadMode(item)"
                  @up="moveRow(1)"
                  @down="moveRow(-1)"
                  @focus="setSelectedColumn"
                ></table-cell>
              </template>
            </div>
          </div>
        </div>
        <div class="excel-table">
          <div
            v-for="(item, index) in data"
            :key="index"
            class="row"
            @mouseover="item.isHover = true"
            @mouseleave="item.isHover = false"
            :class="{
              'is-new': item.isNew,
              'is-selected': item.isSelected,
              'has-error': item.hasError ? item.hasError : false,
              'edit-mode': item.isEdit,
              'is-hover': item.isHover
            }"
            @click.stop="changeToEditMode(item)"
          >
            <template v-for="(cell, j) in header">
              <table-cell
                v-if="j > 1"
                v-model="data[index]"
                :key="j"
                :cssClass="header[j].cssClass"
                :column="header[j].column"
                :list="header[j].list"
                :type="header[j].type"
                :readonly="header[j].readOnly"
                :allowCreate="header[j].allowCreate"
                :remoteMethod="header[j].remoteMethod"
                :selectedColumn="selectedColumn"
                @saved="changeToReadMode(item)"
                @up="moveRow(1)"
                @down="moveRow(-1)"
                @focus="setSelectedColumn"
              ></table-cell>
            </template>
          </div>
        </div>
      </div>
      <div class="excel-footer excel-table">
        <div class="row">
          <template v-for="(item, index) in header">
            <div class="cell" :class="item.cssClass" :key="index">
              <div class="companies-total" v-if="index == 0">
                {{ companiesTotal }}
              </div>
              <div class="contacts-total" v-if="index == 1">
                {{ contactsTotal }}
              </div>
            </div>
          </template>
        </div>

        <div class="actions" v-if="selectedRow">
          <button
            class="button is-icon is-rounded"
            title="Add"
            v-if="selectedRow.id"
            @click="addRow(selectedRow)"
          >
            <span class="icon-plus"></span>
          </button>
          <button
            class="button is-icon is-rounded"
            title="Close"
            v-if="selectedRow.owner_id == userID || !selectedRow.id"
            @click="deleteContact(selectedRow)"
          >
            <span class="icon-close"></span>
          </button>
        </div>
      </div>
      <div class="search-container" v-if="search.active">
        <div class="button is-icon is-rounded" @click="search.active = false">
          <span class="icon-eye"></span>
        </div>

        <div class="active-filters">
          <div
            class="active-filter-item"
            v-for="(item, index) in filters"
            :key="index"
          >
            <el-tag
              closable
              disable-transitions
              type="success"
              @close="removeFilter(index)"
            >
              {{ item.columnLabel }} = {{ item.labelValue }}
            </el-tag>
          </div>
        </div>

        <el-select
          v-if="search.item.type == 'list'"
          v-model="search.value"
          ref="searchbox"
          :placeholder="search.placeholderText"
          :loading-text="selectOptions.loadingText"
          :no-match-text="selectOptions.noMatchText"
          :no-data-text="selectOptions.noDataText"
          clearable
          filterable
          remote
          :remote-method="searchAutocomplete"
          default-first-option
          value-key="id"
          popper-class="search-drop"
          @change="executeSearch"
        >
          <el-option
            v-for="item in search.options"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div
          v-else-if="
            search.item.type == 'date' || search.item.type == 'datetime'
          "
        >
          <el-date-picker
            ref="searchbox"
            v-model="search.value"
            type="daterange"
            range-separator=" "
            start-placeholder=" "
            end-placeholder=" "
            value-format="yyyy-MM-dd"
            :placeholder="search.placeholderText"
            prefix-icon="is-hidden"
            @change="executeSearch"
          >
          </el-date-picker>
        </div>
        <input
          v-else
          v-model="search.value"
          ref="searchbox"
          type="text"
          class="input"
          :placeholder="search.placeholderText"
          @keyup.enter="executeSearch"
          @keyup.esc="exitSearch"
        />
      </div>
    </div>
  </section>
</template>

<script>
import TableHeaderCell from '@/components/TableHeaderCell';
import TableCell from '@/components/TableCell';
import PageHeader from '@/components/PageHeader';
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'ListContacts',
  components: {
    PageHeader,
    TableHeaderCell,
    TableCell
  },
  data() {
    return {
      header: [
        {
          label: 'Company',
          column: 'company_id',
          cssClass: 'company',
          search: true,
          type: 'list',
          list: 'companies',
          allowCreate: true,
          remoteMethod: this.findCompanyImmediate,
          readOnly: true
        },
        {
          label: 'Interface Name',
          column: 'name',
          cssClass: 'interface',
          search: true,
          type: 'text',
          readOnly: false
        },
        {
          label: 'Role',
          column: 'role',
          cssClass: 'role',
          search: true,
          type: 'text',
          readOnly: false
        },
        {
          label: 'Status',
          column: 'status',
          cssClass: 'status',
          search: true,
          type: 'list',
          list: [
            {
              value: 'assigned',
              label: 'Assigned'
            },
            {
              value: 'active',
              label: 'Active'
            },
            {
              value: 'closed',
              label: 'Closed'
            }
          ],
          readOnly: false
        },
        {
          label: 'User',
          column: 'owner_id',
          cssClass: 'user',
          search: true,
          type: 'list',
          list: 'users',
          readOnly: false
        },
        {
          label: 'First Contact',
          column: 'first_contact',
          cssClass: 'date',
          search: true,
          type: 'date',
          readOnly: true
        },
        {
          label: 'P  E  L',
          column: 'fc',
          cssClass: 'pel',
          search: false,
          type: 'group-checkbox',
          readOnly: false
        },
        {
          label: 'Last Contact',
          column: 'last_contact',
          cssClass: 'date',
          search: true,
          type: 'date',
          readOnly: false
        },
        {
          label: 'P  E  L',
          column: 'lc',
          cssClass: 'pel',
          search: false,
          type: 'group-checkbox',
          readOnly: false
        },
        {
          label: 'Next Contact',
          column: 'next_contact',
          cssClass: 'date',
          search: true,
          type: 'date',
          readOnly: false
        },
        {
          label: 'Meeting date',
          column: 'meeting',
          cssClass: 'date',
          search: true,
          type: 'datetime',
          readOnly: false
        },
        {
          label: 'Meeting Status',
          column: 'meeting_status',
          cssClass: 'meeting_status',
          search: true,
          type: 'list',
          list: [
            {
              value: 'scheduled',
              label: 'Scheduled'
            },
            {
              value: 'done',
              label: 'Done'
            },
            {
              value: 'canceled',
              label: 'Canceled'
            }
          ],
          readOnly: false
        },
        {
          label: 'Phone 1',
          column: 'phone1',
          cssClass: 'phone',
          search: true,
          readOnly: false
        },
        {
          label: 'Phone 2',
          column: 'phone2',
          cssClass: 'phone',
          search: true,
          readOnly: false
        },
        {
          label: 'Email 1',
          column: 'email1',
          cssClass: 'email',
          search: true,
          readOnly: false
        },
        {
          label: 'Email 2',
          column: 'email2',
          cssClass: 'email',
          search: true,
          readOnly: false
        },
        {
          label: 'Notes',
          column: 'notes',
          cssClass: 'notes',
          search: true,
          readOnly: false
        }
      ],
      selectOptions: {
        tempValue: null,
        loadingText: 'loading...',
        noMatchText: ' ',
        noDataTextt: ' ',
        placeholderText: ' ',
        options: []
      },
      search: {
        active: false,
        column: '',
        value: '',
        placeholderText: 'Search for...',
        options: [],
        item: null
      },
      interval: null,
      selectedEl: {
        id: '',
        label: ''
      },
      data: [],
      companies: [],
      users: [],
      filters: [] /*{
        company_id: {},
        name: {},
        role: {},
        owner_id: {},
        first_contact: {},
        last_contact: {}
      },*/,
      selectedRow: null,
      backupSelectedRow: null,
      userID: null,
      selectedColumn: null
    };
  },
  mounted() {
    this.userID = localStorage.getItem('userID');
    this.initEvents();
    //default filter with the current user
    this.filters.push({
      columnLabel: this.getColumnById('owner_id').label,
      field: 'owner_id',
      value: localStorage.getItem('userID'),
      labelValue: 'YOU',
      op: '='
    });
    //and another default filter for date
    const startDate = moment()
      .subtract(1, 'year')
      .format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');
    this.filters.push({
      columnLabel: this.getColumnById('next_contact').label,
      field: 'next_contact',
      value: [startDate, endDate], // array com início e fim
      labelValue: `${startDate} - ${endDate}`, // string para mostrar
      op: 'LIKE'
    });
    this.loadCompanies();
    this.loadContacts();
    this.loadUsers();

    document.addEventListener('keydown', event => {
      //event.preventDefault();
      console.log('tab geral', event);
    });
  },
  computed: {
    companiesTotal() {
      return _.uniqBy(this.data, 'company_id').length;
    },
    contactsTotal() {
      return this.data.length;
    }
  },
  methods: {
    initEvents() {
      const target = document.querySelector('body');

      target.addEventListener('paste', event => {
        const paste = (event.clipboardData || window.clipboardData).getData(
          'text/plain'
        );
        if (paste.indexOf('\t') != -1) {
          event.preventDefault();
          this.changeToReadMode(this.selectedRow);
          this.exitSearch();
          this.selectRow(null);
          this.handlePasteEvent(paste);
        }
      });
    },
    handlePasteEvent(text) {
      //if there is a tab char we assume we are dealing with an excel copy paste...
      if (text.indexOf('\t') != -1) {
        const rows = text.split('\n');

        for (let y = rows.length - 1; y >= 0; y--) {
          if (rows[y] == '') {
            continue;
          }
          const cells = rows[y].split('\t');

          const obj = this.addEmptyRow();

          for (let x = 0, h = 0; x < cells.length; x++, h++) {
            if (
              this.header[h].column == 'fc' ||
              this.header[h].column == 'lc'
            ) {
              if (cells[x].toLowerCase() == 'x')
                obj[this.header[h].column + '_phone'] = 1;
              if (cells[x + 1].toLowerCase() == 'x')
                obj[this.header[h].column + '_email'] = 1;
              if (cells[x + 2].toLowerCase() == 'x')
                obj[this.header[h].column + '_linkedin'] = 1;
              x += 2;
            } else if (cells[x]) {
              if (this.header[h].column == 'company_id') {
                const company = _.find(this.companies, ['name', cells[x]]);
                if (company) {
                  obj[this.header[h].column] = company.id;
                } else {
                  //create the company and use the id...
                }
              } else if (this.header[h].column == 'owner_id') {
                const user = _.find(this.users, [
                  'label',
                  cells[x].toUpperCase()
                ]);
                if (user) obj[this.header[h].column] = user.id;
              } else if (this.header[h].column == 'status') {
                if (
                  ['assigned', 'active', 'closed'].includes(
                    cells[x].toLowerCase()
                  )
                ) {
                  obj[this.header[h].column] = cells[x].toLowerCase();
                }
              } else if (this.header[h].column == 'meeting_status') {
                if (
                  ['scheduled', 'done', 'canceled'].includes(
                    cells[x].toLowerCase()
                  )
                ) {
                  obj[this.header[h].column] = cells[x].toLowerCase();
                }
              } else if (
                this.header[h].type == 'date' ||
                this.header[h].type == 'datetime'
              ) {
                obj[this.header[h].column] = moment(cells[x], [
                  'DD-MM-YYYY',
                  'MM/DD/YYYY',
                  'YYYY-MM-DD',
                  'YYYY/MM/DD'
                ]).format('YYYY-MM-DD');
              } else {
                obj[this.header[h].column] = cells[x];
              }
            }
          }
        }
      }
    },
    exitSearch() {
      this.search.active = false;
    },
    getColumnById(column) {
      console.log('get column ', column);
      for (let i = 0; i < this.header.length; i++) {
        if (column == this.header[i].column) return this.header[i];
      }
    },
    checkStatusRuleForSearch() {
      this.header.map(item => {
        if (item.column == 'status') {
          item.search = this.filters.length > 0;
        }
      });

      console.log('check rules', this.filters.length, this.filters[0]);

      //if there is only one filter and is the status we auto remove the status
      if (this.filters.length == 1 && this.filters[0].field == 'status') {
        this.filters = [];
      }
    },
    searchAutocomplete(query) {
      console.log('searchAutocomplete', this.search.column, query);
      if (this.search.column == 'company_id') {
        this.findCompany(query);
      } else if (this.search.column == 'owner_id') {
        this.search.options = this.users.filter(item => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else if (this.search.column == 'status') {
        this.search.options = [
          {
            id: 'assigned',
            value: 'assigned',
            label: 'Assigned'
          },
          {
            id: 'active',
            value: 'active',
            label: 'Active'
          },
          {
            id: 'closed',
            value: 'closed',
            label: 'Closed'
          }
        ];
      } else if (this.search.column == 'meeting_status') {
        this.search.options = [
          {
            id: 'scheduled',
            value: 'scheduled',
            label: 'Scheduled'
          },
          {
            id: 'done',
            value: 'done',
            label: 'Done'
          },
          {
            id: 'canceled',
            value: 'canceled',
            label: 'Canceled'
          }
        ];
      }
    },
    executeSearch() {
      console.log('do search for contacts ', this.search.value);
      //add the filter
      let op = 'LIKE';
      let valueLabel = this.search.value;
      if (['company_id', 'owner_id', 'status'].includes(this.search.column)) {
        op = '=';

        if (this.search.column == 'company_id')
          valueLabel = _.find(this.companies, ['id', this.search.value]).name;
        else if (this.search.column == 'owner_id') {
          valueLabel = _.find(this.users, ['id', this.search.value]).initials;
        }
      }
      let changed = false;
      const column = this.getColumnById(this.search.column);
      if (column.type == 'date' || column.type == 'datetime') {
        valueLabel = this.search.value[0] + ' - ' + this.search.value[1];

        for (let i = 0; i < this.filters.length; i++) {
          if (this.filters[i].field == this.search.column) {
            changed = true;
            this.filters[i] = {
              columnLabel: column.label,
              field: this.search.column,
              value: this.search.value,
              labelValue: valueLabel,
              op: op
            };
          }
        }
      }

      if (!changed) {
        this.filters.push({
          columnLabel: column.label,
          field: this.search.column,
          value: this.search.value,
          labelValue: valueLabel,
          op: op
        });

        console.log('::::', this.filters);
      }
      this.checkStatusRuleForSearch();

      //do the search on DB
      this.loadContacts();

      //hide search
      this.exitSearch();
    },
    activateSearch(item) {
      this.search.options = [];
      this.search.value = '';
      this.search.active = true;
      this.search.column = item.column;
      this.search.item = item;
      this.search.placeholderText = 'Search by ' + item.label + '...';

      this.data.map(obj => {
        if (obj.isSelected) obj.isSelected = false;
        if (obj.isEdit) {
          this.changeToReadMode(obj);
        }
      });

      if (this.selectedRow) {
        this.selectedRow.isSelected = this.selectedRow.isEdit = false;
        this.selectedRow = null;
      }

      this.$nextTick(() => {
        this.$refs.searchbox.focus();
      });
    },
    removeFilter(index) {
      console.log('remove filter', index);
      //this.filters[column] = {};
      this.filters.splice(index, 1);
      this.checkStatusRuleForSearch();
      this.loadContacts();
    },
    findCompany(query) {
      console.log('findCompany', query);
      if (query !== '' && query.trim().length > 2) {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.search.options = this.findCompanyImmediate(query);
        }, 200);
      } else {
        this.search.options = [];
      }
    },
    findCompanyImmediate(query) {
      const arr = this.companies.filter(item => {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
      console.log('findCompanyImmediate', arr);
      if (arr) return arr;
      else return [];
    },
    loadContacts() {
      const query = [];
      this.filters.map(item => {
        let exists = false;
        for (let i = 0; i < query.length; i++) {
          if (query[i].field == item.field) {
            exists = true;
            query[i].op = 'IN';
            if (Array.isArray(query[i].value)) query[i].value.push(item.value);
            else {
              query[i].value = [query[i].value, item.value];
            }
          }
        }

        const column = this.getColumnById(item.field);

        if (!exists) {
          if (column.type == 'date' || column.type == 'datetime') {
            query.push({
              field: item.field,
              value: item.value,
              op: 'LIKE'
            });
            // query.push({
            //   field: item.field,
            //   value: item.value[0],
            //   op: '>='
            // });
            // query.push({
            //   field: item.field,
            //   value: item.value[1],
            //   op: '<='
            // });
          } else {
            query.push({
              field: item.field,
              value: item.value,
              op: item.op
            });
          }
        }
      });

      if (query.length == 0) this.data = [];
      else {
        const args = {
          psize: 200,
          query: JSON.stringify(query)
        };

        this.data = [];
        this.axiosRequest('get', 'contact', args)
          .then(response => {
            console.log(response);

            this.data = _.sortBy(response.data.data, [
              'company_id.name',
              'name',
              'first_contact'
            ]);
            //this.data = response.data.data;
            this.data.map(item => {
              this.$set(item, 'isNew', false);
              this.$set(item, 'isEdit', false);
              this.$set(item, 'isSelected', false);
              this.$set(item, 'isHover', false);
              item.fc_phone = Number(item.fc_phone);
              item.fc_email = Number(item.fc_email);
              item.fc_linkedin = Number(item.fc_linkedin);
              item.lc_phone = Number(item.lc_phone);
              item.lc_email = Number(item.lc_email);
              item.lc_linkedin = Number(item.lc_linkedin);
              console.log(':', item.fc_phone);
              this.$set(item, 'fc_phone', item.fc_phone);
              this.$set(item, 'fc_email', item.fc_email);
              this.$set(item, 'fc_linkedin', item.fc_linkedin);

              this.$set(item, 'lc_phone', item.lc_phone);
              this.$set(item, 'lc_email', item.lc_email);
              this.$set(item, 'lc_linkedin', item.lc_linkedin);

              if (item.status.id) {
                item.status = String(item.status.id);
              }
              if (item.meeting_status.id) {
                item.meeting_status = String(item.meeting_status.id);
              }
              if (item.owner_id.id) {
                item.owner_id = String(item.owner_id.id);
              }
              if (item.company_id.id) {
                item.company_id = String(item.company_id.id);
              }
            });
          })
          .catch(error => {
            console.log(':', error);

            if (error.response.status == 401) {
              this.logout();
            }
          });
      }
    },
    loadUsers() {
      this.axiosRequest('get', 'user', {
        psize: -1,
        query:
          '[{"field": "profile_id", "value": [4,5], "op": "IN"}, {"field": "active", "value": "1", "op": "="}]'
      })
        .then(response => {
          console.log(response);
          this.users = response.data.data;
          this.users.map(item => {
            if (item.initials != '') {
              item.label = item.initials;
            } else {
              const tmp = item.name.split(' ');
              if (tmp.length > 1) {
                item.initials = item.label =
                  tmp[0].substring(0, 1) + tmp[tmp.length - 1].substring(0, 1);
              } else {
                item.initials = item.label = item.name.substring(0, 2);
              }
            }

            item.value = item.id;
            return item;
          });

          this.$store.commit('users/set', this.users);
        })
        .catch(error => {
          console.error(error);
        });
    },
    loadCompanies() {
      this.axiosRequest('get', 'company', {
        psize: -1
      })
        .then(response => {
          console.log(response);
          this.companies = response.data.data;
          this.companies.map(item => {
            item.label = item.name;
            item.value = item.id;
            return item;
          });

          this.$store.commit('companies/set', this.companies);
        })
        .catch(error => {
          console.error(error);
        });
    },
    createCompany(name, obj, callback) {
      this.axiosRequest('post', 'company', {
        name: name
      })
        .then(response => {
          console.log(response);
          const new_company = {
            name: name,
            id: String(response.data.id),
            label: name,
            value: String(response.data.id)
          };
          this.companies.push(new_company);
          this.$store.commit('companies/add', new_company);
          if (callback) {
            obj.company_id = String(response.data.id);
            callback(obj);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    saveContact(obj) {
      //only save who has company and name
      if (!obj.company_id || obj.company_id.id == '' || obj.name == '') {
        if (obj.id != '') {
          obj.isEdit = false;
          if (obj.name == '') obj.name = this.backupSelectedRow.name;
          if (!obj.company_id) {
            obj.company_id = this.backupSelectedRow.company_id;
          }
        } else {
          for (let i = 0; i < this.data.length; i++) {
            if (this.data[i] == obj) {
              this.data.splice(i, 1);
              break;
            }
          }
        }
        return;
      }
      console.log(':', obj);
      if (!obj.status) {
        this.showErrorMessage('Status is a mandatory field');
        return;
      } else if (obj.status == 'closed' && obj.notes.trim() == '') {
        this.showErrorMessage('Notes is a mandatory field for Status Closed');
        return;
      } else if (
        (obj.fc_phone || obj.lc_phone) &&
        obj.phone1.trim() == '' &&
        obj.phone2.trim() == ''
      ) {
        this.showErrorMessage(
          'The phone is mandatory if the contact was made by phone.'
        );
        return;
      } else if (
        (obj.fc_email || obj.lc_email) &&
        obj.email1.trim() == '' &&
        obj.email2.trim() == ''
      ) {
        this.showErrorMessage(
          'The email is mandatory if the contact was made by email.'
        );
        return;
      } else if (
        (obj.meeting_status == 'canceled' || obj.meeting_status == 'done') &&
        obj.notes.trim() == ''
      ) {
        this.showErrorMessage(
          'Notes is a mandatory field if contact already have a meeting done or canceled'
        );
        return;
      } else if (
        obj.first_contact != '' &&
        !obj.fc_phone &&
        !obj.fc_email &&
        !obj.fc_linkedin
      ) {
        this.showErrorMessage(
          'Contact has a first contact defined but no P E L is defined'
        );
        return;
      } else if (
        obj.last_contact != '' &&
        !obj.lc_phone &&
        !obj.lc_email &&
        !obj.lc_linkedin
      ) {
        this.showErrorMessage(
          'Contact has a last contact defined but no P E L is defined'
        );
        return;
      }

      //if user picked is not active
      const user = this.users.find(u => u.id === obj.owner_id);
      console.log(user);
      if (user && user.active == '0') {
        this.showErrorMessage(
          'The user you choose is no longer active, please pick another.'
        );
        return;
      }

      //create logic around next_contact
      if (obj.last_contact == '') {
        if (obj.first_contact) {
          const baseDate = moment(obj.first_contact);
          obj.next_contact = baseDate
            .clone()
            .add(7, 'days')
            .format('YYYY-MM-DD');
        }
      } else {
        const baseDate = moment(obj.last_contact);
        obj.next_contact = baseDate
          .clone()
          .add(7, 'days')
          .format('YYYY-MM-DD');
      }

      if (isNaN(obj.company_id)) {
        this.createCompany(obj.company_id, obj, newObj => {
          this.saveContactDB(newObj);
        });
      } else {
        this.saveContactDB(obj);
      }
    },
    saveContactDB(obj) {
      const clone_original_object = Object.assign({}, this.backupSelectedRow);
      const item = Object.assign({}, obj);
      delete item.isNew;
      delete item.isEdit;
      delete item.isSelected;
      delete item.isHover;
      delete item.hasError;
      item.fc_phone = item.fc_phone ? '1' : '0';
      item.fc_email = item.fc_email ? '1' : '0';
      item.fc_linkedin = item.fc_linkedin ? '1' : '0';
      item.lc_phone = item.lc_phone ? '1' : '0';
      item.lc_email = item.lc_email ? '1' : '0';
      item.lc_linkedin = item.lc_linkedin ? '1' : '0';

      if (typeof item.company_id == 'object')
        item.company_id = item.company_id.id;
      if (typeof item.status == 'object') item.status = item.status.id;
      if (typeof item.meeting_status == 'object')
        item.meeting_status = item.meeting_status.id;
      if (typeof item.owner_id == 'object') item.owner_id = item.owner_id.id;

      let method = 'post';
      let path = 'contact';
      if (item.id) {
        method = 'put';
        path = 'contact/' + item.id;

        //check  if the object changed...
        let differences = false;
        for (const prop in this.backupSelectedRow) {
          if (
            prop == 'isEdit' ||
            prop == 'isNew' ||
            prop == 'isSelected' ||
            prop == 'hasError' ||
            prop == 'isHover'
          )
            continue;

          if (this.backupSelectedRow[prop] != obj[prop]) {
            differences = true;
            break;
          }
        }
        //no diferences no save
        if (!differences) return;
      }
      this.axiosRequest(method, path, item)
        .then(response => {
          console.log(response);
          if (response.data.id) {
            obj.id = response.data.id;
            obj.isNew = false;
          }

          obj.hasError = false;

          this.selectRow(null);
          this.showSuccessMessage('Contact saved');
        })
        .catch(error => {
          if (error.response && error.response.data.message)
            this.showErrorMessage(error.response.data.message);
          else this.showErrorMessage('Error saving the contact');

          if (method == 'put') {
            for (let i = 0; i < this.data.length; i++) {
              if (this.data[i].id == obj.id) {
                this.data[i].company_id = clone_original_object.company_id;
                this.data[i].name = clone_original_object.name;

                this.selectedRow = null;
                break;
              }
            }
          } else {
            this.$set(obj, 'hasError', true);
          }
        });
    },
    deleteContact(item) {
      //soft delete
      if (!item.id) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i] == item) {
            //this.data.splice(i, 1);
            this.$delete(this.data, i);
            break;
          }
        }
        return;
      }
      //DB delete
      this.axiosRequest('delete', 'contact/' + item.id)
        .then(response => {
          console.log(response);

          for (let i = 0; i < this.data.length; i++) {
            if (this.data[i] == item) {
              //this.data.splice(i, 1);
              this.$delete(this.data, i);
              break;
            }
          }
          this.selectedRow = null;

          this.showSuccessMessage('Contact Deleted');
        })
        .catch(error => {
          console.error(error);
        });
    },
    changeToEditMode(item) {
      console.log('double click fired', item);
      let user = '';
      if (item.owner_id != '')
        user = this.$store.getters['users/byId'](item.owner_id);

      if (!user)
        user = {
          active: false
        };

      if (
        item.owner_id == '' ||
        item.owner_id == this.userID ||
        !user.active ||
        (item.first_contact == '' && item.last_contact == '')
      ) {
        item.isEdit = true;
      } else {
        let is_ok = true;
        if (item.first_contact != '') {
          const diff = Math.abs(
            moment(item.first_contact).diff(moment(), 'days')
          );
          if (diff < 15) is_ok = false;
        }

        if (item.last_contact != '') {
          const diff = Math.abs(
            moment(item.last_contact).diff(moment(), 'days')
          );
          if (diff < 15) is_ok = false;
        }
        if (is_ok) item.isEdit = true;
        else this.showErrorMessage('The record is locked with another user');
      }

      if (item.isEdit) {
        setTimeout(() => {
          //if the backup is the object, we don't want to create a new backup
          if (
            this.backupSelectedRow != null &&
            this.backupSelectedRow.id == item.id
          )
            return;

          if (item != null) this.backupSelectedRow = Object.assign({}, item);
        }, 100);

        this.exitSearch();
        this.data.map(obj => {
          if (item == null || obj.id != item.id) {
            obj.isSelected = false;
            if (obj.isEdit) {
              this.changeToReadMode(obj);
            }
          }
        });
      }

      this.selectedRow = item;
    },
    changeToReadMode(item) {
      console.log('changeToReadMode', item);
      if (item) {
        item.isEdit = false;
        this.saveContact(item);
      }
    },
    selectRow(item) {
      if (item && item.isEdit) {
        return;
      }

      if (this.selectedRow == item) {
        this.selectedRow = null;
        if (item) item.isSelected = false;
      } else {
        this.selectedRow = item;
        if (item) item.isSelected = true;
      }

      if (item != null) this.exitSearch();
      this.data.map(obj => {
        if (item == null || obj.id != item.id) {
          obj.isSelected = false;
          if (obj.isEdit) {
            this.changeToReadMode(obj);
          }
        }
      });

      this.backupSelectedRow = null;
    },
    matchScroll() {
      this.$refs['headertable'].scrollLeft = this.$refs['bodytable'].scrollLeft;

      this.$refs['freezedtable'].scrollTop = this.$refs['bodytable'].scrollTop;
    },
    addRow(row) {
      console.log('addRow', row);
      if (!row) {
        document.querySelector('.v-scrollable-content').scrollTop = 0;
      }
      this.selectRow(null);
      this.selectedRow = this.addEmptyRow(row);
    },
    addEmptyRow(row) {
      console.log('addEmptyRow', row);
      const obj = {
        id: '',
        company_id: '',
        name: '',
        role: '',
        status: 'active',
        owner_id: this.userID,
        first_contact: '',
        fc_phone: 0,
        fc_email: 0,
        fc_linkedin: 0,
        last_contact: '',
        lc_phone: 0,
        lc_email: 0,
        lc_linkedin: 0,
        next_contact: '',
        phone1: '',
        phone2: '',
        email1: '',
        email2: '',
        meeting: '',
        meeting_status: '',
        notes: '',
        isEdit: true,
        isNew: true,
        isSelected: false,
        isHover: false
      };

      if (row) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].id == row.id) {
            if (i < this.data.length - 1) this.data.splice(i + 1, 0, obj);
            else this.data.push(obj);
            break;
          }
        }
      } else {
        this.data.unshift(obj);
      }

      return obj;
    },
    moveRow(dir) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].isEdit) {
          if (dir == 1) {
            if (i > 0) {
              this.changeToEditMode(this.data[i - 1]);
              break;
            }
          } else {
            if (i < this.data.length - 1) {
              this.changeToEditMode(this.data[i + 1]);
              break;
            }
          }
        }
      }
    },
    setSelectedColumn(column) {
      this.selectedColumn = column;
    }
  }
};
</script>

<style lang="scss">
.contacts-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .list {
    flex-grow: 1;
    height: 100%;
    position: relative;

    .h-scrollable-content {
      overflow: hidden;
      height: 50px;
    }

    .v-scrollable-content {
      overflow: auto;
      height: calc(100vh - 160px);
      display: flex;
      padding-left: 343px;
    }

    .excel-footer {
      background: #e2f4f0;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50px;
      color: $brand-color;
      font-weight: bold;
      display: flex;
      align-items: center;
      text-align: left;

      .row {
        &:hover {
          background: transparent !important;
        }
      }

      .cell {
        border-right: none !important;
      }

      .companies-total {
        width: 150px;
        padding-left: 10px;
      }

      .contacts-total {
        width: 190px;
        padding-left: 10px;
      }

      .actions {
        width: 150px;
        background: $primary;
        color: #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        justify-content: center;
        display: flex;
        align-items: center;

        .button {
          margin: 0 5px;
        }
      }
    }

    .excel-header-wrap {
      //width: $excel-width;
      width: 3140px;
      box-sizing: content-box;
      padding-right: 20px;
    }

    .company {
      width: 150px;

      .text {
        width: 150px - $cell-padding * 2;
      }
    }

    .interface {
      width: 190px;

      .text {
        width: 190px - $cell-padding * 2;
      }
    }

    .role {
      width: 190px;

      .text {
        width: 190px - $cell-padding * 2;
      }
    }

    .status {
      width: 105px;

      .text {
        width: 105px - $cell-padding * 2;
      }
    }

    .user {
      width: 140px;

      .text {
        width: 140px - $cell-padding * 2;
      }
    }

    .date {
      width: 140px;

      .text {
        width: 140px - $cell-padding * 2;
      }
    }

    .pel {
      width: 105px;

      .text {
        width: 105px - $cell-padding * 2;
      }
    }

    .meeting_status {
      width: 140px;

      .text {
        width: 140px - $cell-padding * 2;
      }
    }

    .phone {
      width: 120px;
      .text {
        width: 120px - $cell-padding * 2;
      }
    }

    .email {
      width: 150px;
      .text {
        width: 150px - $cell-padding * 2;
      }
    }

    .notes {
      width: 250px;
      .text {
        width: 250px - $cell-padding * 2;
      }
    }

    .excel-header {
      display: table;
      min-width: $excel-width;
      border-spacing: 1px;
      border-collapse: separate;
      height: 50px;
      background: $brand-color;
      color: #ffffff;
      text-transform: uppercase;
      padding-left: 342px;

      .company,
      .interface {
        position: fixed !important;
        left: 1px;
        background: #16b69e;
        z-index: 10;
        display: flex;
        align-items: center;
        width: 151px;
      }

      .interface {
        left: 152px;
        width: 191px;
      }

      .pel {
        text-align: center;
        letter-spacing: 8px;
      }

      .row,
      .cell {
        height: 50px;
        font-size: 13px;
        position: relative;
      }

      .cell {
        .actions {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 50px;
          justify-content: center;
          align-items: center;
          background: $brand-color;

          .button {
            margin: 0 4px;
          }
        }

        &:hover {
          .actions {
            display: flex;
          }
        }
      }
    }

    .freeze {
      position: fixed;
      width: 343px;
      left: 0;
      height: calc(100vh - 180px);
      overflow: hidden;
      background: #fff;
      z-index: 10;
    }

    .excel-table {
      display: table;
      min-width: 2168px;
      border-spacing: 1px;
      border-collapse: separate;
      height: 0;

      &.freezed {
        width: 100%;
        min-width: auto;
      }

      .cell {
        border-bottom: solid 1px #eaeaea;
        border-right: solid 1px #ffffff;
      }

      .row {
        &:hover,
        &.is-selected,
        &.is-hover {
          background: #e5e5e5;
        }

        &.edit-mode {
          background: rgba($row-selected-color, 0.5);
        }

        &.has-error {
          background: rgba($danger, 0.5) !important;
        }

        &.is-new {
          &:hover {
            background: rgba($row-selected-color, 0.5);
          }
        }
      }
    }

    .row {
      display: table-row;
      height: 40px;

      &.is-new {
        background: $row-selected-color !important;
      }
    }

    .cell {
      display: table-cell;
      vertical-align: middle;
      padding: 0 $cell-padding + 2px;
      text-align: left;
      height: 41px;
      font-size: 14px;
      overflow: hidden;
    }
  }

  input {
    max-width: 100%;
  }

  .search-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    width: 100%;
    background: $brand-color;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 20px;
    z-index: 100;

    .button {
      margin-right: 5px;
    }

    .input,
    .el-input__inner,
    .el-select .el-input .el-input__inner {
      background: $brand-color;
      border: none;
      color: #ffffff;
      padding-left: 10px;

      @include myplaceholder;
    }
  }

  .active-filters {
    display: flex;

    .active-filter-item {
      margin-right: 5px;
    }
  }
}
</style>
